module.exports = __webpack_public_path__ + "img/lc_bg.7025d4c5.png";